import { Edit } from "@wix/wix-ui-icons-common";
import lodash from "lodash";
import React from "react";
import { TIPTAP_FIGURE_TYPE } from "./../ricos-content/index.js";
import { createDeleteButton } from "./../_shared/plugin-toolbar/create-delete-button.js";
import { createLinkButton } from "./../_shared/plugin-toolbar/create-link-button.js";
import { createNodeAlignmentButton } from "./../_shared/plugin-toolbar/create-node-alignment-button.js";
import { createReplaceButton } from "./../_shared/plugin-toolbar/create-replace-button.js";
import { createSettingsButton } from "./../_shared/plugin-toolbar/create-settings-button.js";
import { createNodeSizeButton } from "./../_shared/plugin-toolbar/node-size-button/create-node-size-button.js";
import { createSeparator } from "./../_shared/plugin-toolbar/separator/create-separator.js";
import { getNodeInSelection } from "./../_shared/resolvers/get-node-in-selection.js";
import { FLOATING_PLUGIN_TOOLBAR } from "./../toolbars-v3/index.js";
import {
  IMAGE_BUTTONS,
  IMAGE_EDITOR_MODAL_ID,
  IMAGE_SETTINGS_MODAL_ID,
  PLUGIN_TOOLBAR_BUTTON_ID_IMAGE_EDITOR
} from "./consts.js";
import { PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON } from "./data-hooks.js";
import { handleImageUpload } from "./handle-image-upload.js";
import { ImageEditorModal } from "./image-editor-modal/image-editor-modal.js";
import { Settings } from "./settings/settings.js";
import { ImageEditorButton } from "./toolbar/ImageEditorButton.js";
const getToolbarButtons = (config, services) => {
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    createSettingsButton({
      modalId: IMAGE_SETTINGS_MODAL_ID,
      showLabel: true,
      command: ({ referenceElement, attributes: { selectedNode } }) => {
        modals?.togglePluginPanel({
          id: IMAGE_SETTINGS_MODAL_ID,
          Component: Settings,
          componentProps: {
            referenceElement,
            nodeId: selectedNode.attrs.id,
            config
          },
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          onClickOutside: {
            on: "pointerup",
            handler: lodash.noop
          },
          focusReturnElement: referenceElement,
          isMobile: services.context.isMobile
        });
      }
    }),
    createSeparator({
      visible: getIsEditImageVisibleResolver(config, services, isMobile)
    }),
    createNodeSizeButton({
      services,
      modalId: IMAGE_BUTTONS.size,
      options: ["SMALL", "CONTENT", "FULL_WIDTH", "ORIGINAL"]
    }),
    createNodeAlignmentButton({ services, modalId: IMAGE_BUTTONS.alignment }),
    createLinkButton(services),
    createReplaceButton({
      tooltip: "ReplaceImageButton_Tooltip",
      command: ({ attributes: { selectedNode }, publicCommands }) => {
        handleImageUpload({
          services,
          config,
          publicCommands,
          nodeId: selectedNode.attrs.id
        });
      }
    }),
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID_IMAGE_EDITOR,
      type: "modal",
      dataHook: PLUGIN_TOOLBAR_IMAGE_EDITOR_BUTTON,
      icon: Edit,
      tooltip: "ImageEditorButton_Tooltip",
      command: ({ attributes: { selectedNode } }) => {
        modals?.openModal({
          Component: ImageEditorModal,
          id: IMAGE_EDITOR_MODAL_ID,
          componentProps: {
            nodeId: selectedNode.attrs.id,
            src: selectedNode.attrs?.image?.src?.id,
            config
          },
          positioning: { placement: "top" },
          layout: "fullscreen"
        });
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(ImageEditorButton, { toolbarItem }),
      attributes: {
        visible: getIsEditImageVisibleResolver(config, services, isMobile),
        selectedNode: getNodeInSelection
      }
    },
    createSeparator(),
    createDeleteButton({
      command: (data) => {
        const figures = data.tiptapEditor.$nodes(TIPTAP_FIGURE_TYPE);
        const selectedFigure = figures?.find((f) => {
          return f.firstChild?.node.attrs.id === data.attributes.selectedNode.attrs.id;
        });
        if (selectedFigure) {
          data.tiptapEditor.chain().focus().deleteNode(selectedFigure.attributes.id).run();
        }
      }
    })
  ];
};
const getIsEditImageVisibleResolver = (config, services, isMobile) => ({
  resolve: () => config.imageEditor && Boolean(services.wixInstance()?.uid) && !isMobile
});
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
